import { Skeleton } from '../../Skeleton'
import { TablePagination } from '../../TablePagination'
import { TableSkeleton } from '../../TableSkeleton'

import { ENTITY_PROFILE_TABS_LOADING_TABS_COUNT } from './EntityProfileTabsLoading.constants'
import { getEntityProfileTabsLoadingTabWidth } from './EntityProfileTabsLoading.utils'

import * as styles from './EntityProfileTabsLoading.module.css'

function EntityProfileTabsLoading({
  tabsClassName = styles.tabs,
  tabsCount = ENTITY_PROFILE_TABS_LOADING_TABS_COUNT,
}) {
  return (
    <>
      <div className={tabsClassName}>
        <div className={styles.tabList}>
          {Array.from({ length: tabsCount }).map((_, index) => (
            <div className={styles.tab} key={index}>
              <Skeleton
                className={styles.tabText}
                style={{ width: getEntityProfileTabsLoadingTabWidth(index) }}
              />
            </div>
          ))}
        </div>
      </div>
      <div className={styles.toolbar}>
        <div className={styles.filters}>
          <Skeleton className={styles.filterButton} />
          <Skeleton className={styles.filterTemplate} />
        </div>
        <Skeleton className={styles.actions} />
      </div>
      <div className={styles.controlBar}>
        <Skeleton className={styles.actions} />
      </div>
      <TableSkeleton inline />
      <TablePagination isSkeleton className={styles.pagination} />
    </>
  )
}

export default EntityProfileTabsLoading
